<template>
  <div class="">
    <com-head :leadtext="toptext"></com-head>
    <div class="menu-key">
      <p class="key-text">
        关键词 <span>&nbsp;&nbsp;(内容由CPS中安网撰写)</span>
      </p>
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane
          v-for="(list, index) in antarray"
          :key="index"
          :label="list.keyword"
          :name="index.index"
        >
          <div class="key-content">
            <div class="keycon-title">
              <h3>{{ list.title }}</h3>
              <div class="aa"></div>
            </div>
            <div v-html="list.content" id="content-style-tre"></div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import comhead from "./comhead.vue";
import { trend } from "../api/api";

export default {
  components: {
    "com-head": comhead,
  },
  data() {
    return {
      toptext:
        "2020年安防市场砥砺前行，上下游供应链中断、项目订单延期等问题集中出现，历经一年，不少企业逐渐回归正轨，产业生态链转型升级，迎来“重生”契机，企业业绩从第三季度回暖，全年业绩可期。",
      antarray: [
        {
          content: "",
          create_time: 0,
          keyword: "",
          title: "",
        },
      ],
      // 关键词默认值
      activeName: "0",
      //折叠面板默认值
      activeNames: ["1"],
    };
  },
  methods: {
    //获取数据
    getData: function () {
      console.log("sds");
      var gain = {
        cate_id: 31,
        where: "[year,=,2020]",
      };
      trend(gain).then((res) => {
        this.antarray = res.data.list;
        console.log(res.data.list);
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
@import "../assets/public.less";
/deep/.key-content h5 {
  font-family: PingFang SC;
  margin-top: 30px !important;
  text-align: left;
  margin: 30px 0px;
  margin-left: -30px;
}
#content-style-tre {
  color: #666666;
  width: 100%;
  margin-top: 30px;
}
</style>
<style scoped>
/* 表格样式 */
.key-content >>> table {
  width: 100% !important;
  font-size: 12px !important;
}
.key-content >>> table tr {
  height: 41px !important;
  border-top: 1px solid #ececec !important;
  text-align: center !important;
}
.key-content >>> table tr:nth-child(1) td {
  font-size: 18px !important;
  color: #666666 !important;
}
.key-content >>> table tr td {
  font-size: 16px !important;
  color: #666666 !important;
  border-bottom: 1px solid #ececec !important;
  font-family: 'Avenir', Helvetica, Arial, sans-serif !important;
}
.key-content >>> table tr td span {
  color: #666666 !important;
}
.key-content >>> table tbody tr:nth-child(1) {
  background: #f9f9fa !important;
  font-weight: bold !important;
  text-align: center !important;
}
</style>
<style scoped>
.key-content >>>  p{
  text-align: justify;
  font-size: 16px;
  color: #444444;
  padding: 0px 20px;
  line-height: 30px;
}
.key-content >>> h5{
  color: #fff;
  height: 42px;
  background-color: #6F53C7;
  background-image: linear-gradient(to right, #FA1D80 , #3712B2);
  opacity: 0.7;
  margin: 0 auto;
}
.key-content >>> h5 span{
  font-size: 20px !important;
  line-height: 42px;
}
</style>


// WEBPACK FOOTER //
// src/components/performance.vue